import NotificationsParent from '../components/Notifications/NotificationsParent'
import { Paper, Typography, useTheme } from "@mui/material";

const NotificationsPage = (props: any) => {
    const theme = useTheme();
    return (
        <Paper 
          component={"main"} 
          className='off-white'
          sx={{backgroundColor: theme.palette.background.default}}
        >
      <nav className='sub'>
        <Typography variant="h6">
          All Error Notifications
        </Typography>
      </nav>
      <div className="container">
            <NotificationsParent 
                allApplications={props.allApplications} 
                notificationList={props.notificationList} 
                acknowledgeNotification={props.acknowledgeNotification} 
              callNotificationsAPI={props.callNotificationsAPI}/>
      </div>

        </Paper>
    )
}

export default NotificationsPage
